import { render, staticRenderFns } from "./LocalblockView.vue?vue&type=template&id=b9189fb2"
import script from "./LocalblockView.vue?vue&type=script&lang=js"
export * from "./LocalblockView.vue?vue&type=script&lang=js"
import style0 from "./LocalblockView.vue?vue&type=style&index=0&id=b9189fb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports